import materialPreviews from '../../services/materials/material-previews';
import imagePathCreator from '../image-path-creator';

export type AnimatedEntity = Material & {
    imgUrl: string;
    previewsStorage: MaterialFilePreview[][];
    stopAnimation: boolean;
    timeouts: {
        [key: string]: ReturnType<typeof setTimeout>;
    };
};

export default {
    mouseOut(e: Event, item: AnimatedEntity, imageProxyConfig = {}): void {
        const element = e.currentTarget as HTMLDivElement;

        if (element) {
            const originalImg = item.imgUrl || (item.firstPreviewImage ? item.firstPreviewImage.plain : '');
            const url = imagePathCreator.optimizedImg({ preview: originalImg }, imageProxyConfig);
            const i = new Image();

            item.stopAnimation = true;

            if (item.timeouts) {
                clearTimeout(item.timeouts.tmout2);
                clearTimeout(item.timeouts.tmout3);
                clearTimeout(item.timeouts.tmout4);
                clearTimeout(item.timeouts.tmout5);
            }

            // @ts-ignore
            if (element.style['background-image'] === url) {
                return;
            }

            i.src = url;
            i.onload = () => {
                element.style['background-position'] = 'left';
                element.style['background-image'] = `url("${url}")`;
                element.style.transition = 'initial';
            };
        }
    },

    mouseOver(e: Event, item: AnimatedEntity, imageProxyConfig = {}): void {
        let urls = [] as MaterialFilePreview[];
        const distance = -380;
        const interval = 2000;
        const element = e.currentTarget as HTMLDivElement;

        if (element) {
            item.previewsStorage = item.previewsStorage || [];
            item.timeouts = item.timeouts || {};

            const animate = (el: HTMLDivElement, urlCopy: MaterialFilePreview[]) => {
                if (item.stopAnimation) {
                    return;
                }

                el.style.transition = '1s linear';
                // @ts-ignore
                el.style['background-position'] = `${distance}px, left`;

                item.timeouts.tmout2 = setTimeout(() => {
                    const nextEl = urlCopy.length > 2 ? urlCopy[2].plain : urlCopy[0].plain;

                    if (item.stopAnimation) {
                        return;
                    }

                    el.style.transition = 'initial';
                    // @ts-ignore
                    el.style['background-image'] = `url("${imagePathCreator.optimizedImg(
                        { preview: urlCopy[1].plain },
                        imageProxyConfig
                    )}"), url("${imagePathCreator.optimizedImg({ preview: nextEl }, imageProxyConfig)}")`;
                    // @ts-ignore
                    el.style['background-position'] = 'left, left';

                    const part = urlCopy.splice(0, 1);

                    urlCopy = [...urlCopy, ...part];

                    item.timeouts.tmout3 = setTimeout(() => {
                        animate(el, urlCopy);
                    }, 100);
                }, interval);
            };

            const starter = (previews: MaterialFilePreview[]) => {
                urls = previews;

                if (urls.length > 1) {
                    element.style.transition = '0s linear !important';
                    element.style['background-image'] = `${
                        element.style['background-image']
                    }, url("${imagePathCreator.optimizedImg({ preview: urls[1].plain }, imageProxyConfig)}")`;
                    element.style['background-position'] = 'left, left';

                    item.timeouts.tmout5 = setTimeout(() => {
                        animate(element, urls);
                    }, 800);
                }
            };

            item.stopAnimation = false;

            item.timeouts.tmout4 = setTimeout(() => {
                if (item.previewsStorage[item.id]) {
                    starter(item.previewsStorage[item.id].slice());

                    return;
                }

                materialPreviews.get({ limit: 10, page: 1 }, { id: item.id }).then((response) => {
                    item.previewsStorage[item.id] = response.data.items.slice();
                    starter(item.previewsStorage[item.id].slice());
                });
            }, 300);
        }
    }
};
